"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Callbacks = /** @class */ (function () {
    function Callbacks() {
        this.onOpen = null;
        this.onClose = null;
        this.onSelect = null;
        Object.seal(this);
    }
    return Callbacks;
}());
exports.default = Callbacks;
//# sourceMappingURL=Callbacks.js.map